import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Crown, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-lg shadow-xl border-b border-gray-100' 
        : 'bg-transparent'
    }`}>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-emerald-800 to-teal-700 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-3 w-3" />
              <span>+94 11 XXX XXXX</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="h-3 w-3" />
              <span>exports@claudesspecial.lk</span>
            </div>
          </div>
          <div className="hidden md:block">
            <span className="text-emerald-200">🇱🇰 Authentic Sri Lankan Heritage</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/cinnamon-design-2" className="flex items-center space-x-3 group">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                  <Crown className="h-7 w-7 text-white" />
                </div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-amber-400 rounded-full flex items-center justify-center">
                  <span className="text-xs">✨</span>
                </div>
              </div>
              <div>
                <div className={`text-2xl font-bold transition-colors duration-300 ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  Claude's Special
                </div>
                <div className={`text-xs font-medium transition-colors duration-300 ${
                  isScrolled ? 'text-emerald-600' : 'text-emerald-200'
                }`}>
                  Ceylon Cinnamon Exports
                </div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-1">
              <Link
                to="/cinnamon-design-2"
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 ${
                  isActive('/cinnamon-design-2') 
                    ? 'bg-emerald-600 text-white shadow-lg' 
                    : isScrolled
                      ? 'text-gray-700 hover:bg-emerald-50 hover:text-emerald-700'
                      : 'text-white hover:bg-white/20'
                }`}
              >
                Home
              </Link>
              <Link
                to="/ceylon-cinnamon-design-2"
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 ${
                  isActive('/ceylon-cinnamon-design-2') 
                    ? 'bg-emerald-600 text-white shadow-lg' 
                    : isScrolled
                      ? 'text-gray-700 hover:bg-emerald-50 hover:text-emerald-700'
                      : 'text-white hover:bg-white/20'
                }`}
              >
                Our Cinnamon
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-700 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/20'
                }`}
              >
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden pb-4">
              <div className="bg-white rounded-2xl shadow-2xl p-4 space-y-2 border border-gray-100">
                <Link
                  to="/cinnamon-design-2"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 rounded-xl text-base font-medium transition-colors duration-200 ${
                    isActive('/cinnamon-design-2') 
                      ? 'text-emerald-700 bg-emerald-50' 
                      : 'text-gray-700 hover:text-emerald-700 hover:bg-emerald-50'
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/ceylon-cinnamon-design-2"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 rounded-xl text-base font-medium transition-colors duration-200 ${
                    isActive('/ceylon-cinnamon-design-2') 
                      ? 'text-emerald-700 bg-emerald-50' 
                      : 'text-gray-700 hover:text-emerald-700 hover:bg-emerald-50'
                  }`}
                >
                  Our Cinnamon
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;